import { Text } from '@change/ds-core-ui/next';

type Props = {
	title: string;
	description: string;
};

export function Alert({ title, description }: Props): React.JSX.Element {
	return (
		<div className="bg-fill-error-weaker border-stroke-error-weak text-typography-error rounded-medium flex flex-col gap-1 border border-solid p-6">
			<Text className="text-typography-error" variant="body" size="large" fontWeight="bold">
				{title}
			</Text>
			<Text className="text-typography-error" variant="body" size="medium">
				{description}
			</Text>
		</div>
	);
}
